/* eslint-disable max-lines */
/* eslint-disable sort-keys */
export const styledForm = {
    flex: 1,
    padding: '$formPadding',
}

export const styledFieldset = {
    border: 0,
    margin: '0 0 1rem 0',
    padding: '0',
    variants: {
        hidden: {
            true: {
                position: 'fixed',
                visibility: 'hidden',
                zIndex: '-1',
            },
        },
    },
}

export const styledHR = {
    border: 0,
    borderTop: '1px solid $hrBorder',
    margin: '1rem 0 1rem 0',
}

export const styledInput = {
    '&::placeholder': {
        color: '$inputPlaceholder',
        opacity: 1, /* Firefox */
    },
    '&:-webkit-autofill, &:autofill': {
        'backgroundColor': '$inputBackgroundAutopopulated !important',
        'color': '$inputTextAutopopulated !important',
        'borderColor': '$inputBorderAutopopulated',
        'WebkitBoxShadow': 'inset 0 0 0 30px $inputBackground',
        'caretColor': '$inputText',
        '&::first-line': {fontSize: 'input'},
        '&:focus-visible': {
            backgroundColor: '$inputBackgroundAutopopulatedFocus !important',
            borderColor: '$inputBorderAutopopulatedFocus',
            color: '$inputTextAutopopulatedFocus !important',
        },
    },
    '&:disabled': {
        backgroundColor: '$inputBackgroundDisabled',
        borderColor: '$inputBorderDisabled',
        color: '$inputTextDisabled',
        cursor: 'not-allowed',
    },
    '&:not(:disabled)': {
        '&[aria-invalid="true"]': {
            backgroundColor: '$inputBackgroundInvalid',
            borderColor: '$inputBorderInvalid',
            color: '$inputTextInvalid',
        },
        '&:focus-visible': {
            backgroundColor: '$inputBackgroundFocus',
            borderColor: '$inputBorderFocus',
            color: '$inputTextFocus',
            outline: 'none',
        },
        '&:active': {
            backgroundColor: '$inputBackgroundActive',
            borderColor: '$inputBorderActive',
            color: '$inputTextActive',
        },
        '&:hover': {
            backgroundColor: '$inputBackgroundHover',
            borderColor: '$inputBorderHover',
            color: '$inputTextHover',
        },
    },
    '&[type="date"]': {display: 'block'},
    'backgroundColor': '$inputBackground',
    'borderColor': '$inputBorder',
    'borderRadius': '$input',
    'borderStyle': '$input',
    'borderWidth': '$input',
    'color': '$inputText',
    'display': 'flex',
    'fontSize': '$input',
    'fontStyle': '$input',
    'fontVariant': '$input',
    'fontFamily': '$input',
    'fontWeight': '$input',
    'marginTop': '6px',
    'padding': '$inputPaddingVertical $inputPaddingHorizontal',
    'variants': {
        correct: {
            true: {
                backgroundColor: '$inputBackgroundValid',
                borderColor: '$inputBorderValid',
                color: '$inputTextValid',
            },
        },
    },
}

export const styledLabel = {
    '&:first-child': {marginTop: 0},
    'cursor': 'pointer',
    'display': 'inline-flex',
    'fontSize': '$labelText',
    'fontWeight': '$labelText',
    'marginRight': '10px',
    'marginTop': '12px',
}

export const styledSmall = {
    fontSize: '$smallText',
    variants: {error: {true: {color: '$error'}}},
}

export const styledSmallBottom = {
    ...styledSmall,
    color: '$inputPlaceholder',
}

export const styledSmallDescription = {
    ...styledSmall,
    color: '$smallText',
    display: 'flex',
}

export const styledLegend = {
    fontSize: '$legendText',
    fontWeight: '$legendText',
    marginBottom: '$legendTextMargin',
    paddingInlineEnd: 0,
    paddingInlineStart: 0,
}

export const styledDescription = {
    color: '$formDescriptionText',
    fontSize: '$formDescriptionText',
    marginBottom: '$formDescriptionMargin',
}

export const styledSelect = {
    'appearance': 'none',
    '-webkit-appearance': 'none',
    'backgroundColor': '$inputBackground',
    'borderColor': '$inputBorder',
    'borderRadius': '$input',
    'borderStyle': '$input',
    'borderWidth': '$input',
    'boxSizing': 'border-box',
    'color': '$inputText',
    'cursor': 'pointer',
    'lineHeight': '$input',
    'fontSize': '$input',
    'fontStyle': '$input',
    'fontVariant': '$input',
    'fontFamily': '$input',
    'fontWeight': '$input',
    'marginBottom': '12px',
    'marginTop': '6px',
    'padding': '$inputPaddingVertical calc($inputPaddingHorizontal + 24px) $inputPaddingVertical calc($inputPaddingHorizontal - 2px)',
    'width': '100%',
    '&:disabled': {
        backgroundColor: '$inputBackgroundDisabled',
        borderColor: '$inputBorderDisabled',
        color: '$inputTextDisabled',
        cursor: 'not-allowed',
    },
    '&:not(:disabled)': {
        '&:focus-visible': {
            backgroundColor: '$inputBackgroundFocus',
            borderColor: '$inputBorderFocus',
            color: '$inputTextFocus',
            outline: 'none',
        },
        '&:active': {
            backgroundColor: '$inputBackgroundActive',
            borderColor: '$inputBorderActive',
            color: '$inputTextActive',
        },
        '&:hover': {
            backgroundColor: '$inputBackgroundHover',
            borderColor: '$inputBorderHover',
            color: '$inputTextHover',
        },
    },
    'variants': {
        compact: {
            true: {
                backgroundPositionY: '4px',
                margin: 0,
                padding: 'calc($inputPaddingVertical - 3px) calc($inputPaddingHorizontal + 20px) calc($inputPaddingVertical - 3px) calc($inputPaddingHorizontal - 2px)',
            },
        },
        invalid: {
            true: {
                backgroundColor: '$inputBackgroundInvalid',
                borderColor: '$inputBorderInvalid',
                color: '$inputTextInvalid',
            },
        },
    },
}

export const styledTextarea = {
    ...styledInput,
    resize: 'vertical',
}

const shared = {
    boxSizing: 'border-box',
    font: 'inherit',
    gridArea: '1 / 1 / 2 / 2',
    padding: '10px',
}

export const styledGrowWrap = {
    '& > textarea': {
        ...shared,
        '&::placeholder': {color: '$inputPlaceholder'},
        '&:focus': {
            borderColor: '$inputBorderFocus',
            outline: 'none',
        },
        '&:hover': {borderColor: '$inputBorderHover'},
        'backgroundColor': '$inputBackground',
        'borderColor': '$inputBorder',
        'borderRadius': '$input',
        'borderStyle': 'solid',
        'borderWidth': '1px',
        'caretColor': '$inputText',
        'color': '$inputText',
        'margin': 0,
        'maxHeight': '8rem',
        'overflowY': 'auto',
        'resize': 'none',
    },
    '&::after': {
        ...shared,
        content: 'attr(data-replicated-value) ""',
        visibility: 'hidden',
        whiteSpace: 'pre-wrap',
    },
    'display': 'grid',
    'marginBottom': '0.5rem',
    'marginTop': '6px',
    'maxHeight': '8rem',
    'overflowY': 'hidden',
}
